import React from "react";
import CommonListItemsComp from "../common/List";

const ListNewDevelopments = (props) => {
    return <CommonListItemsComp {...props}/>
}

export default ListNewDevelopments;
